import React, { useEffect, useState } from "react";
import "../Styles/OurNews.css";
import useFirestoreCollection from "../utils/useFirestoreCollection";

const OurNews = () => {
  const [news, setNews] = useState("");
  const { loading: adminLoading, data: adminData } = useFirestoreCollection(
    "administration"
  );

  useEffect(() => {
    if (adminData && adminData.length > 0) {
      setNews(adminData[0].news || "");
    }
  }, [adminData]);

  // Hide the bar entirely while loading or when there's nothing to announce
  if (adminLoading) return null;
  if (!news || !news.trim()) return null;

  return (
    <aside
      className="news-ticker"
      role="region"
      aria-label="Latest news"
      aria-live="polite"
    >
      <div className="news-ticker__label">
        <span className="news-ticker__dot" aria-hidden="true"></span>
        <span className="news-ticker__label-text">NEWS</span>
      </div>
      <div className="news-ticker__viewport">
        <div className="news-ticker__track">
          <span className="news-ticker__item">{news}</span>
        </div>
      </div>
    </aside>
  );
};

export default OurNews;
